import { App, type URLOpenListenerEvent } from '@capacitor/app';

import { replaceState } from 'pkg/router/state';

// Pre-mount writes route via window.location (read by withBrowserState's
// initial state); post-mount dispatches router:replace.
let appRendered = false;

const CONSUMED_LAUNCH_URL_KEY = 'deepLinkLaunchUrlConsumed';

export function markAppRendered(): void {
	appRendered = true;
}

function handleDeepLink(url: string): void {
	let target: URL;

	try {
		target = new URL(url);
	} catch {
		return;
	}

	const path = `${target.pathname}${target.search}`;

	window.history.replaceState({}, '', path);

	if (appRendered) {
		replaceState(path);
	}
}

// Register before React mounts so warm-resume appUrlOpen events aren't lost.
export async function initDeepLinks(): Promise<void> {
	App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
		handleDeepLink(event.url);
	});

	// A cold start loads `/`; a deep path means MainActivity restored the route.
	if (window.location.pathname !== '/') {
		return;
	}

	const launch = await App.getLaunchUrl();

	if (!launch?.url) {
		return;
	}

	// Once per process: sessionStorage survives reloads and renderer kills.
	try {
		if (sessionStorage.getItem(CONSUMED_LAUNCH_URL_KEY) === launch.url) {
			return;
		}

		sessionStorage.setItem(CONSUMED_LAUNCH_URL_KEY, launch.url);
	} catch {
		// Storage unavailable: apply it anyway.
	}

	handleDeepLink(launch.url);
}
